import { canShowAppPages } from '@members/feature-toggles';

export const useGetApps = () => canShowAppPages();
